module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_5_m.64f014aa052ba819dc2ace9f1b9ec534.png";